import React, { Component } from 'react';
import Link from 'gatsby-link';
import UserLinks from '../UserLinks/UserLinks';
import MAPIMG from './img/map2.png';
import SolarPowerLogo from '../../img/SolarPower_White.png';
import './Footer.css';

class InfoFooter extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#0d2c54' }} className="g-color-white-opacity-0_8 g-py-60">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 g-mb-40 g-mb-0--lg">
              <a className="d-block g-mb-20" href="index.html">
                <img className="img-fluid" src={SolarPowerLogo} alt="Solar-Power Logo" />
              </a>

              <div className="u-heading-v3-1 g-brd-white-opacity-0_3 g-mb-25">
                <h2 className="u-heading-v3__title h6 text-uppercase g-brd-primary">Contacto</h2>
              </div>

              <address
                className="g-bg-no-repeat g-line-height-2 g-mt-minus-4"
                style={{ backgroundImage: `url(${MAPIMG})` }}
              >
                Seminario 605, Providencia
                <br />
                Santiago, Chile
                <br />
                Phone: (+56) 23 267 8448
                <br />
                Email:{' '}
                <a href="mailto:contacto@solar-power.cl" className="">
                  contacto@solar-power.cl
                </a>
              </address>
            </div>

            <div className="col-lg-3 col-md-6 g-mb-40 g-mb-0--lg">
              <div className="u-heading-v3-1 g-brd-white-opacity-0_3 g-mb-25">
                <h2 className="u-heading-v3__title h6 text-uppercase g-brd-primary">
                  Direcciones utiles
                </h2>
              </div>

              <nav className="text-uppercase1">
                <ul className="list-unstyled g-mt-minus-10 mb-0">
                  <li className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                    <h4 className="h6 g-pr-20 mb-0">
                      <a
                        href="https://www.solar-power.cl/"
                        className="g-color-white-opacity-0_8 g-color-white--hover"
                      >
                        Inicio
                      </a>

                      <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                    </h4>
                  </li>
                  <li className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                    <h4 className="h6 g-pr-20 mb-0">
                      <a
                        href="https://www.solar-power.cl/about"
                        className="g-color-white-opacity-0_8 g-color-white--hover"
                      >
                        Quienes Somos
                      </a>
                      <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                    </h4>
                  </li>
                  <li className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                    <h4 className="h6 g-pr-20 mb-0">
                      <a
                        href="https://www.solar-power.cl/catalogo"
                        className="g-color-white-opacity-0_8 g-color-white--hover"
                      >
                        Catálogo
                      </a>
                      <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                    </h4>
                  </li>
                  <li className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                    <h4 className="h6 g-pr-20 mb-0">
                      <a
                        href="https://www.solar-power.cl/sale"
                        className="g-color-white-opacity-0_8 g-color-white--hover"
                      >
                        Ofertas
                      </a>
                      <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                    </h4>
                  </li>
                  <li className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                    <h4 className="h6 g-pr-20 mb-0">
                      <Link to="/" className="g-color-white-opacity-0_8 g-color-white--hover">
                        Calculadora Energética
                      </Link>
                      <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                    </h4>
                  </li>
                  <li className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                    <h4 className="h6 g-pr-20 mb-0">
                      <a
                        href="https://www.solar-power.cl/contacto"
                        className="g-color-white-opacity-0_8 g-color-white--hover"
                      >
                        Contacto
                      </a>
                      <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                    </h4>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="u-heading-v3-1 g-brd-white-opacity-0_3 g-mb-25">
                <h2 className="u-heading-v3__title h6 text-uppercase g-brd-primary">Nosotros</h2>
              </div>

              <p className="mb-0" style={{ fontSize: '1rem' }}>
                SOLARPOWER es una empresa del holding FADILUK®.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const CopyRightFooter = ({ config }) => (
  <footer style={{ backgroundColor: '#0d2c54' }} className="g-color-white-opacity-0_8 g-py-20">
    <div className="container">
      <div className="row">
        <div className="col-md-8 text-center text-md-left g-mb-15 g-mb-0--md">
          <div className="d-lg-flex">
            <small className="d-block g-font-size-default g-mr-10 g-mb-10 g-mb-0--md">
              {config.copyright}
            </small>
          </div>
        </div>
        <UserLinks config={config} labeled />
      </div>
    </div>
  </footer>
);

const Footer = ({ config }) => (
  <div>
    <InfoFooter />
    <CopyRightFooter config={config} />
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js